import React, { useState } from "react";
import { FlatList } from "react-native";
import { Button, Text, View } from "./Themed";
import { useColors } from "../constants/useColors";


type ToggleProps = {
    options: {key:string, label:string, [key:string]:any}[],
    background_color?:string,
    toggle_padding?:number,
    border_radius?:number,
    padding?:number,
    title_renderer?:(option:any) => any,
    active_toggle_color?:string,
    inactive_toggle_color?:string,
    inactive_title_color?:string,
    active_title_color?:string,
    selected_option?: string,
    onSelectOption:(key:string) => void
}
const Toggle = ({ options, background_color, padding, title_renderer, active_title_color, toggle_padding, border_radius, inactive_title_color, inactive_toggle_color ,active_toggle_color, selected_option, onSelectOption }:ToggleProps) => {
    const Colors = useColors()
    const [ toggle_width, setToggleWidth ] = useState(300);
    const MIN_OPTION_WIDTH = 50
    let option_width = toggle_width - 10
    if(options.length > 0){
        option_width = (toggle_width - 10) / options.length
        if(option_width < MIN_OPTION_WIDTH){ option_width = MIN_OPTION_WIDTH }
    }

    const renderOptions = (data:{item:{ key:string, label:string }, index:number}) => {
        const selected = selected_option == data.item.key ? true : false
        const last = data.index == options.length -1 ? true: false
        const first = data.index == 0 ? true : false
        return (
            <Button 
                float={selected ? true : false}
                style={{ 
                    width: option_width, 
                    padding:toggle_padding ?? 15, 
                    borderWidth:0,
                    backgroundColor:selected?active_toggle_color ?? Colors.toggle.button.active : inactive_toggle_color ?? Colors.toggle.button.inactive,
                    borderTopLeftRadius: first ? border_radius ?? 8 : 0,
                    borderBottomLeftRadius: first? border_radius ?? 8 : 0,
                    borderTopRightRadius: last ? border_radius ?? 8 : 0,
                    borderBottomRightRadius: last ? border_radius ?? 8 : 0
                    
                }}
                onPress={() => onSelectOption(data.item.key)}
            >
                {title_renderer ?
                <View style={{flex:1}} transparent>
                    {title_renderer(data.item)}
                </View>
                :
                <Text 
                    textAlign='center' 
                    size={14} 
                    color={selected?active_title_color??Colors.toggle.text.active: inactive_title_color ?? Colors.toggle.text.inactive} 
                    weight={selected?'bold':'regular'}>{data.item.label}</Text>
                }
            </Button>
        )
    }
    
    return (
        <View style={{ borderRadius:border_radius ?? 8, backgroundColor:background_color ?? Colors.toggle.background, padding:padding??4 }} onLayout={(ev) => {
            const { width } = ev.nativeEvent.layout;
            setToggleWidth(width)
        }}>
            <FlatList
                key='toggle'
                data={options}
                showsHorizontalScrollIndicator={false}
                horizontal
                renderItem={renderOptions}
                keyExtractor={(item) => item.key.toString()}
            />
        </View>
    )
}


export default Toggle